import { useEffect, useRef } from 'react';
import { twcn } from '@web/ui/core/utils';

interface CheckboxProps {
  checked: boolean | 'indeterminate';
  onChange: (checked: boolean) => void;
  label: string;
  disabled?: boolean;
}

/** Checkbox nativo (acessível e dirigível no jsdom); `label` vira aria-label. */
export function Checkbox({
  checked,
  onChange,
  label,
  disabled,
}: Readonly<CheckboxProps>): React.JSX.Element {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = checked === 'indeterminate';
  }, [checked]);
  return (
    <input
      ref={ref}
      type="checkbox"
      aria-label={label}
      checked={checked === true}
      disabled={disabled}
      onChange={(e) => {
        onChange(e.target.checked);
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
      className={twcn('size-4 cursor-pointer accent-primary disabled:cursor-not-allowed')}
    />
  );
}
